import React, {Component} from 'react';
// helpers
import {getFirstDownMarketNameById} from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {getGameTitle} from "../../../../../helpers/eventHelpers";

class LockedBetFirstDown extends Component {

    render() {
        let eventName = getGameTitle(this.props.betSelection.Bets[0].Title, this.props.betSelection.Bets[0].EventTime, this.props.store.getState().vpp.systemLanguage);
        let betType = getText(getFirstDownMarketNameById(this.props.betSelection.Bets[0].Market.Id), this.props.store);
        let odd = this.props.betSelection.Bets[0].Market.Price;

        //TODO add selection
        let selection = ['{selectionPlaceHolder}'];

        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           betType={betType} odd={odd} names={selection} eventName={eventName}
                           isSettledBet={this.props.isSettledBet}/>);
    }
}

export default LockedBetFirstDown;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/components/lockedBetFirstDown.js